import { useEffect } from 'react'

import {
  addPrintChartSnapshots,
  hasPrintChartSnapshots,
  removePrintChartSnapshots,
  printToPdf,
} from '@/utils/printPdf.helpers'

/**
 * Wires a page for PDF export and returns the click handler for its button.
 * The same snapshotting is hooked to the print EVENTS so Cmd+P exports the
 * page identically — the button is the reliable path because it also waits for
 * the snapshots to decode.
 *
 * @param {string} selector CSS selector matching the page's ECharts containers
 */
export const usePrintToPdf = (selector) => {
  useEffect(() => {
    // window.print() fires this, so the button path arrives here with snapshots
    // it has already decoded. Re-snapshotting would swap in undecoded copies and
    // throw that wait away.
    const handleBeforePrint = () => {
      if (!hasPrintChartSnapshots()) {
        addPrintChartSnapshots(selector)
      }
    }
    window.addEventListener('beforeprint', handleBeforePrint)
    window.addEventListener('afterprint', removePrintChartSnapshots)
    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint)
      window.removeEventListener('afterprint', removePrintChartSnapshots)
      removePrintChartSnapshots()
    }
  }, [selector])

  return () => printToPdf(selector)
}
